(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dew-newsletter"] && !Shopify.designMode) return;
  try {
    
  var ok = document.querySelector('[data-newsletter-success]');
  if (ok && location.search.indexOf('customer_posted=true') !== -1) {
    ok.scrollIntoView({ block: 'center' });
    ok.focus({ preventScroll: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dew-signup-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.dew-popup');
    if (!root) return;
    var KEY = 'dew-popup';
    var DAY = 86400000;
    var design = root.dataset.designMode === 'true';
    var enabled = root.dataset.enabled === 'true';
    var form = root.querySelector('form');
    var posted = location.search.indexOf('customer_posted=true') !== -1;
    var state = null;
    try { state = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    var lastFocus = null;

    function open() {
      if (!root.hidden) return;
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var first = root.querySelector('input:not([type=hidden]), button[data-popup-close]');
      if (first) first.focus();
    }
    function close(reason) {
      root.hidden = true;
      document.documentElement.style.overflow = '';
      if (reason) { try { localStorage.setItem(KEY, JSON.stringify({ state: reason, at: Date.now() })); } catch (e) {} }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    root.querySelectorAll('[data-popup-close]').forEach(function (el) {
      el.addEventListener('click', function () { close(root.querySelector('.dew-popup__submit') ? 'dismissed' : 'subscribed'); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close('dismissed'); });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = root.querySelectorAll('a[href], button, input:not([type=hidden]), [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    if (form) form.addEventListener('submit', function () { try { localStorage.setItem(KEY, JSON.stringify({ state: 'submitted', at: Date.now() })); } catch (e) {} });

    // Just came back from a popup signup: show the thank-you state once.
    if (posted && state && state.state === 'submitted') { open(); return; }
    if (design) {
      // Theme editor: show it whenever the merchant selects this section.
      document.addEventListener('shopify:section:select', function (e) { if (root.closest('.shopify-section') === e.target) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (root.closest('.shopify-section') === e.target) close(); });
      return;
    }
    if (!enabled) return;
    if (state && (state.state === 'subscribed' || state.state === 'submitted')) return;
    if (state && state.state === 'dismissed' && Date.now() - state.at < 30 * DAY) return;
    if (/[?&]customer_posted=true/.test(location.search)) return;

    var fired = false;
    function trigger() { if (fired) return; fired = true; open(); }
    setTimeout(trigger, Number(root.dataset.delay) * 1000);
    window.addEventListener('scroll', function () {
      if (window.scrollY > (document.documentElement.scrollHeight - innerHeight) * 0.5) trigger();
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dew-visit"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dew-visit__zip[aria-controls]').forEach(function (toggle) {
    var form = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!form) return;
    var input = form.querySelector('.dew-zip__input');
    var result = form.querySelector('.dew-zip__result');
    var zones = form.dataset.zones.split('|').map(function (pair) {
      var i = pair.indexOf('":');
      return { name: JSON.parse(pair.slice(0, i + 1)), zips: (JSON.parse(pair.slice(i + 2)) || '').split(/[^0-9]+/).filter(Boolean) };
    });
    toggle.addEventListener('click', function () {
      var open = form.hidden;
      form.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) input.focus();
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var zip = (input.value.match(/\d{5}/) || [''])[0];
      if (!zip) {
        result.className = 'dew-zip__result dew-zip__result--no';
        result.textContent = 'Enter a five-digit ZIP code.';
        input.focus();
        return;
      }
      var zone = zones.find(function (z) { return z.zips.indexOf(zip) !== -1; });
      if (zone) {
        result.className = 'dew-zip__result';
        result.textContent = 'Yes \u2014 we deliver to ' + zip + ' (' + zone.name + ') for $' + form.dataset.fee + '. Order by ' + form.dataset.cutoff + ' for same-day delivery.';
      } else {
        result.className = 'dew-zip__result dew-zip__result--no';
        result.textContent = 'Not yet \u2014 ' + zip + ' is outside our delivery area. We deliver around Manchester, the Seacoast, and Newburyport, and pickup is free in all three.';
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
